import BlockchainAddressFragment from 'components/blockchainAddress/fragment'
import Fragment from 'delv/Fragment.js'

export default new Fragment(`id
status
blockchainAddressByBlockchainAddressId{
    ${BlockchainAddressFragment}
}`)
